import * as React from 'react'

function SecurityIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={18.5} height={19.5} viewBox="0 0 18.5 19.5" {...props}>
      <g
        data-name="Group 7814"
        transform="translate(1674.25 -15297.176)"
        fill="none"
        stroke="CurrentColor"
        strokeWidth={1.5}
      >
        <path
          data-name="Rectangle 3286"
          d="M-1665 15297.926h0a4.5 4.5 0 014.5 4.5v2.5h0-9 0v-2.5a4.5 4.5 0 014.5-4.5z"
        />
        <path data-name="Path 13394" d="M-1665.173 15312.379v-3.355" strokeLinejoin="round" />
        <path data-name="Rectangle 3284" transform="translate(-1673.5 15304.926)" d="M0 0H17V11H0z" />
      </g>
    </svg>
  )
}

export default SecurityIcon
